<div>
  <page-tab [tabconfig]="tabConfig()" [activeTab]="activeTab()" (activeTabEmitter)="changeActiveTab($event)">
  </page-tab>

  @if (isGraphicViewTabActive()) {
    <div>
      <networkgraph [topology]="topology()" [subscription]="subscription()" #chart></networkgraph>
    </div>
  } @else if (isConfigTabActive()) {
    <div class="section">
      <div>
        @for (circuit of circuits(); track circuit.subscriptionInstanceId) {
          <connection [circuit]="circuit" [subscription]="subscription()" [connectionNumber]="$index + 1"></connection>
        }
      </div>
    </div>
  }
</div>
